export class SearchQueryType {
  public static readonly CARRIER_CONNECTABLE_ALTERNATIVE_ARTICLE: string = 'CARRIER_CONNECTABLE_ALTERNATIVE_ARTICLE';
  public static readonly ACCESSORY_ALTERNATIVE_ARTICLE: string = 'ACCESSORY_ALTERNATIVE_ARTICLE';
  public static readonly ACCESSORY_ARTICLE: string = 'ACCESSORY_ARTICLE';
}
